// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"70f8a6dce46242f7d226","453":"530fa0bce6678439f7cd","522":"ac05b6042fedbfaeaf2a"}[chunkId] + ".js";
};